import { GUMLET_BASE_URL } from "constants/index";
import { logger } from "helpers/logger";
/* eslint-disable import/prefer-default-export */

export const toVideoCDNUrl = (newUrl: string): string => {
  if (!newUrl) return "";

  try {
    const pathname = newUrl.startsWith("http") ? new URL(newUrl).pathname : `/${newUrl}`;

    return `${GUMLET_BASE_URL}${pathname}?original=true`;
  } catch (error) {
    logger.error("Error in toVideoCDNUrl:", error);
    return "";
  }
};
